const state = () => ({
    loading: false,
    dialog: false,
    dialogType: '',
    dialogMessage: '',
    dialogTitle: '',
    onYesClicked: null,
});

const mutations = {
    showMessage(state: any, payload: any) {
        if (Array.isArray(payload.msg)) {
            state.dialogMessage = '<ul>';
            payload.msg.forEach((element: string) => {
                state.dialogMessage = `${state.dialogMessage}<li>${element}</li>`;
            });
            state.dialogMessage = `${state.dialogMessage}</ul>`;
        } else {
            state.dialogMessage = payload.msg;
        }
        state.dialog = true;
        state.dialogType = payload.type;
        state.dialogTitle = payload.title;
        state.onYesClicked = payload.onYesClicked;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
